var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-switch',_vm._g({attrs:{"label":_vm.item.name},on:{"change":_vm.updateOptions},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.item.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }